// extracted by mini-css-extract-plugin
export default {"root":"FilterCard_root__lRDOP"};